const adultPath = `M -1.5 0 
A 3 3 0 1 1 1.5 0 
A 13 13 0 0 1 6 6
A 12 12 0 0 1 2.3 4
A 18 18 0 0 1 2.5 14
A 14 14  0 0 0 0 9
A 14 14  0 0 0 -2.5 14
A 18 18 0 0 1 -2.3 4
A 12 12 0 0 1 -6 6
A 13 13 0 0 1 -1.5 0
z`;

const elderPath = `M -1.2 0.5 
A 3 3 0 1 1 0.8 -0.9 
A 16 16 0 0 1 6 14
A 14 14 0 0 0 2.5 9
A 14 14 0 0 1 -1 14
A 16 16 0 0 0 -1.5 5.5
A 16 16 0 0 1 -4.5 5.5
L -4.5 13
L -6 13
L -6 4.5
A 12 12 0 0 0 -1.2 0.5
z`;

const childPath = `M -1.5 0 
A 3 3 0 1 1 1.5 0 
A 15 15 0 0 1 5 2
A 12 12 0 0 1 1.7 2
A 12 12 0 0 1 2.5 6
A 9  9  0 0 1 0 4
A 9  9  0 0 1 -2.5 6
A 12 12 0 0 1 -1.7 2
A 12 12 0 0 1 -5 2
A 15 15 0 0 1 -1.5 0
z`;

const deathPath = `M -3 -5 
A 3 3 0 0 1 3 -5
L 5 -5
L 5 10
L -5 10
L -5 -5
z
M 1 1
L 3 -1
L 2 -2
L 0 0
L -2 -2
L -3 -1
L -1 1
L -3 3
L -2 4
L 0 2
L 2 4
L 3 3
z`;

export { adultPath, elderPath, childPath, deathPath };
